import React from 'react';

const DialogContent = ({ children, ...props }) => <section className="modal-card-body">{children}</section>;

export default DialogContent;
